import { Box } from '@material-ui/core'
import React from 'react'
import { FaWindowClose } from 'react-icons/fa'



interface Props {
    onClick?: () => void
}

export function CloseIcon(props: Props) {

    return (
        <span style={{ padding: '0 5px', cursor: 'pointer' }}>
            <FaWindowClose {...props} style={{ position: 'relative', transform: 'translateY(3px)' }} size={20} />
        </span>
    )
}
